'use client'

import useTimeout from '@/hooks/use-timeout'
import copyToClipboard from '@/utils/copy-to-clipboard'
import React, { forwardRef, useState } from 'react'
import Tooltip from '../tooltip'

export interface CopyToClipboardProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  copiedText?: string
  duration?: number
  text: string | (() => string)
}

const CopyToClipboard = forwardRef(function CopyToClipboard(
  props: CopyToClipboardProps,
  ref: React.ForwardedRef<HTMLButtonElement>
) {
  const {
    children,
    copiedText = 'Copied!',
    duration = 1500,
    onClick,
    text,
    ...other
  } = props

  const [copied, setCopied] = useState(false)
  const timer = useTimeout()

  const handleCopy = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(event)

      if (event.defaultPrevented) {
        return
      }
    }

    copyToClipboard(typeof text === 'function' ? text() : text)

    setCopied(true)

    timer.start(duration, () => {
      setCopied(false)
    })
  }

  return (
    <Tooltip show={copied} title={copiedText} placement='top'>
      <button ref={ref} aria-label='Copy' onClick={handleCopy} {...other}>
        {children}
      </button>
    </Tooltip>
  )
})

export default CopyToClipboard
